import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, Menu } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import useStyles from './styles';
export const AdminAccountMenu = observer(_ref => {
  let selectedAccount = _ref.selectedAccount,
    menuTriggerExternal = _ref.menuTriggerExternal,
    handleShowEditAdminAccountModal = _ref.handleShowEditAdminAccountModal,
    handleShowDeleteAdminAccountModal = _ref.handleShowDeleteAdminAccountModal,
    setModalAdminAccountData = _ref.setModalAdminAccountData;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const MenuTriggerInternal = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t('general.to_do')), /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }));
  };
  return /*#__PURE__*/React.createElement("span", {
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.todoDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '10-admin-account-menu'
  }, menuTriggerExternal !== undefined ? menuTriggerExternal : /*#__PURE__*/React.createElement(MenuTriggerInternal, null)), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    disabled: handleShowEditAdminAccountModal === undefined,
    onClick: event => {
      if (handleShowEditAdminAccountModal !== undefined) {
        event.stopPropagation();
        setModalAdminAccountData(selectedAccount);
        handleClose();
        handleShowEditAdminAccountModal(true);
      }
    },
    'custom-attribute': '11-admin-account-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('admin_page.edit_admin_account')), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    disabled: handleShowDeleteAdminAccountModal === undefined,
    onClick: event => {
      if (handleShowDeleteAdminAccountModal !== undefined) {
        event.stopPropagation();
        setModalAdminAccountData(selectedAccount);
        handleClose();
        handleShowDeleteAdminAccountModal(true);
      }
    },
    'custom-attribute': '12-admin-account-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  }), t('admin_page.delete_admin_account'))));
});